import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { ArtisanEdgeRoutes, CustomLoginComponent } from '@tmhcc/artisan-edge';
import {
  OktaLoginComponent,
  LogoutComponent
} from '@tmhcc-ng-lib/framwork/okta-login';

export function onAuthRequired(oktaAuth, injector) {
  const router = injector.get(Router);
  router.navigate(['/login']);
}

const routes: Routes = [
  {
    path: 'login-mfa',
    component: CustomLoginComponent
  },
  {
    path: 'login',
    component: OktaLoginComponent
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  ...ArtisanEdgeRoutes,

  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
